import React from "react";
import { useTranslation } from "react-i18next";
import { LinkContainer, OverlayTrigger } from "components/common";
import { Button } from "components/bootstrap";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { LICENSE_SUBJECTS } from "license/constants";
import ForwarderRoutes from "forwarder/Routes";
const CreateForwarderButton = ({ buttonTitle }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const {
    data: { valid: isValidLicense },
    isInitialLoading
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.forwarder);
  if (isInitialLoading) {
    return null;
  }
  return isValidLicense ? /* @__PURE__ */ React.createElement(LinkContainer, { to: ForwarderRoutes.CREATE }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, buttonTitle)) : /* @__PURE__ */ React.createElement(OverlayTrigger, { rootClose: true, overlay: /* @__PURE__ */ React.createElement(React.Fragment, null, t("create_forwarder_button.disabled_no_license")), placement: "top" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", className: "disabled" }, buttonTitle));
};
export default CreateForwarderButton;
